import FormatDate from "../helpers/FormatDate";

const ViewModal = ({ dependentList, onClose, translationMap }) => {
  return (
    <>
      <div
        className="modal fade Custom_Modal_Box show"
        id="dependentdetails"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{ display: "block" }}>
        
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="Title_Inner_Box">
                <h6 className="MainTitleOne">
                  {translationMap?.dependentDetails}
                </h6>
              </div>
            </div>
            <div className="modal-body">
              <div className="Manage_Dependent_Modal_Box">
                <div className="Name_box">
                  <span className="symbol_box">
                    {dependentList?.PatientFirstName?.[0]}
                    {dependentList?.patientLastName?.[0]}
                  </span>
                  <h6 className="MainTitleOne">
                    {dependentList?.PatientFirstName ?
                    dependentList.PatientFirstName.charAt(0).toUpperCase() +
                    dependentList.PatientFirstName.slice(1).toLowerCase() :
                    ""}{" "}
                    {dependentList?.patientLastName ?
                    dependentList.patientLastName.charAt(0).toUpperCase() +
                    dependentList.patientLastName.slice(1).toLowerCase() :
                    ""}
                  </h6>
                </div>
                <div className="status_main_box">
                  <div className="content_box">
                    <ul className="detail_box">
                      <li>
                        <p>
                          <span>{translationMap?.mrn}: </span>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a>{dependentList?.patientMRN || "N/A"}</a>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span>{translationMap?.dob}: </span>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a>{FormatDate(dependentList?.dateofBirth)}</a>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span>{translationMap?.gender}: </span>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a>
                            {dependentList?.patientSex === "Female" ?
                            translationMap?.female :
                            translationMap?.male}
                          </a>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span>{translationMap?.nationality}: </span>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a>{dependentList?.fullNationality || "N/A"}</a>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span>{translationMap?.phoneNumber}:</span>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a>
                            {dependentList?.patientMobile.replace(/\s+/g, "") ||
                            "N/A"}
                          </a>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span>{translationMap?.emiratesId}: </span>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a>{dependentList?.patientAEID || "N/A"}</a>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer modal_footer_btn_box2">
              <button
                type="button"
                className="btn bluetrans_btn_link"
                data-dismiss="modal"
                onClick={onClose}>
                
                {translationMap?.close}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>);

};

export default ViewModal;